import CustomisableFooter from '@rsa-digital/evo-shared-components/components/Footer/CustomisableFooter';
import { StyledGrid } from '@rsa-digital/evo-shared-components/components/Footer/CustomisableFooter/styles';
import { Container } from '@rsa-digital/evo-shared-components/components/Footer/FooterCompliance/styles';
import { SectionGridItem } from '@rsa-digital/evo-shared-components/components/Footer/Section/styles';
import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled from 'styled-components';

export const StyledCustomisableFooter = styled(CustomisableFooter)`
  ${StyledGrid} {
    padding-top: ${spacing(3)};

    ${mediaQuery.tabletLandscape` 
      padding-top: ${spacing(6)};
    `}
  }

  ${SectionGridItem} {
    padding-bottom: 0;
  }

  ${Container} {
    padding-top: ${spacing(7)};
    padding-bottom: ${spacing(3)};

    ${mediaQuery.tabletLandscape` 
      padding-bottom: ${spacing(6)};
    `}
  }
`;
